import React, {useState} from 'react'
import '../css/general/BottomBar.css'
import { NavLink, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const MobileSidebar = () => {
    const [showLogout, setShowLogout] = useState(false);
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem(('isAdmin'));
    const isSubAdmin = localStorage.getItem(('isStaff'));

    const handleLogout = () => {
        localStorage.removeItem('userData');
        localStorage.removeItem('isAdmin', 'true');
        localStorage.removeItem('isStaff', 'true');
        navigate('/');
        window.location.reload();
    }


    return (
        <>
            <section className='bottom-bar-area sticky-bottom d-lg-none d-md-none'>
                <div className='container'>

                    <div className='d-flex justify-content-between'>
                        {isAdmin &&
                            <>
                                <NavLink activeClassName="active" to='/dashboard' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-house-circle-check"></i>
                                    <p className='my-0'>Home</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/profile' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-circle-user"></i>
                                    <p className='my-0'>Profile</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/manage-orders' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-list"></i>
                                    <p className='my-0'>Orders</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/add-product' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-square-plus"></i>
                                    <p className='my-0'>Product</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/add-branch' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-user-plus"></i>
                                    <p className='my-0'>Branch</p>
                                </NavLink>

                                <Link activeClassName="active" className='bottom-bar-text' onClick={() => setShowLogout(true)}>
                                    <i class="fa-solid bottom-bar-icon fa-share"></i>
                                    <p className='my-0'>Log Out</p>
                                </Link>
                            </>
                        }

                        {isSubAdmin &&
                            <>
                                <NavLink activeClassName="active" to='/branch-dashboard' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-house-circle-check"></i>
                                    <p className='my-0'>Home</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/profile' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-circle-user"></i>
                                    <p className='my-0'>Profile</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/my-medicine' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-store"></i>
                                    <p className='my-0'>Store</p>
                                </NavLink>

                                <Link activeClassName="active" className='bottom-bar-text' onClick={() => setShowLogout(true)}>
                                    <i class="fa-solid bottom-bar-icon fa-share"></i>
                                    <p className='my-0'>Log Out</p>
                                </Link>
                            </>
                        }

                    </div>
                    {/* row ends */}

                </div>
            </section>

            {showLogout && (
    <>
              <section className='delete-dialog px-3' onClick={() => setShowLogout(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Do you Really want to Log Out?</p>
              <button className='success-btn' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowLogout(false)}>No</button>
            </div>
          </section>

    </>
)}

        </>
    )
}

export default MobileSidebar
